/* eslint-disable no-shadow */
/* eslint-disable no-empty */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable*/
// import { Button } from '@mui/material';
import { connect } from 'react-redux';
import Chip from '@mui/material/Chip';
import DownloadIcon from '@mui/icons-material/Download';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import moment from 'moment';
import {
	useHistory,
	useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { analyticsAction, formActions, modalActions } from '../../../Actions';
import { ListTable } from '../../../Components/ListTable';
import { POItemsModal } from '../../../Components/Modals/POItemsModal';
import styles from './FMSOrdersListPage.module.scss';
import { VanImageModal } from '../../../Components/Modals/VanImageModal';
import assetServices from '../../../Services/AssetServices/asset.services';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal } from '../../../Components/Modals';
import ListFinderHeader from '../../../Components/ListFinderHeader/ListFinderHeader';
import { urls } from '../../../Constants';
import { Button } from '@/Components/ui/button';
import {
	filtersInfoChip,
	getUnitConvertedQuantity,
	handleOrderStatus,
	handleResponseStreamDownload,
	useSearch,
} from '@/Helpers';
import analyticsServices from '@/Services/analytics.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import SearchBar from '@/Components/SearchBar/SearchBar';
import { Filter, RefreshCcw } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { Tooltip } from '@mui/material';
import { SelectPicker } from 'rsuite';
import shiftServices from '@/Services/shift.service';

const PO_TYPE_MAP = {
	1: 'ORDER',
	2: 'CMS',
	3: 'CAPEX',
	4: 'SERVICE',
	5: 'FMCG',
};

const COLMAP = {
	'PO Id': 'id',
	'Production ID': 'productionPlan',
	'Production Plan Name': 'productionPlanDescription',
	'To Be Used On': 'toBeUsedOn',
	Status: 'orderStatus',
	'Deliver To Process': 'fromProcessName',
	'Deliver From': 'fromStoreName',
	'Deliver To': 'storeName',
	'Deliver From Process': 'toProcessName',
	'Order Name': 'clientPoId',
	'Order Type': 'subType',
	'PO Type': 'type',
	Shift: 'shiftName',
	// 'Quantity Required': 'quantityRequired',
	// 'Total Produced': 'totalProduced',
	'Avg. Hourly Scans': 'avgScans',
	'CREATED ON': 'createdAt',
	'SCHEDULED FOR': 'scheduledAt',
	'SCHEDULED END': 'scheduledEnd',
	'Order Completion': 'orderCompletion',
};

const TABLE_COLUMNS = [
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production Plan Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'To Be Used On',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'PO Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Shift',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Completion',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
	// {
	// title: 'Quantity Required',
	// config: {
	// type: 'DATA',
	// },
	// },
	// {
	// title: 'Total Produced',
	// config: {
	// type: 'DATA',
	// },
	// },
	{
		title: 'Avg. Hourly Scans',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'CREATED ON',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SCHEDULED FOR',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SCHEDULED END',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Workers',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Download',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'ACTION',
		config: {
			type: 'CANCEL',
		},
	},
];

const dateTypeArr = [
	{
		label: 'CREATED ON',
		value: 'ordered',
	},
	{
		label: 'SCHEDULED FOR',
		value: 'scheduled',
	},
	{
		label: 'Planned For',
		value: 'plannedFor',
	},
];

function FMSOrdersListPage(props) {
	const {
		data,
		toggleModal,
		toggleAlert,
		fetchOrdersList,
		toggleFiltersDrawer,
	} = props;
	const [update, setUpdate] = useState(-1);
	const history = useHistory();
	const location = useLocation();
	const [exportFilter, setExportFilter] = useState({});
	const [search, setSearch] = useState({});
	const [filterValue, setFilterValue] = useState({});
	const exportFilterRef = useRef({});
	const [isRefresh, setIsRefresh] = useState(false);
	const [viewPackagesModal, setViewPackagesModal] = useState({
		open: false,
		data: [],
	});

	const handleViewPackages = async (item) => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: `Fetching Packages...`,
		});
		try {
			const res = await inventoryAnalyticsServices.fetchFmcgPackages({
				params: { orderId: item?.id },
			});
			if (
				res?.statusCode === 200 ||
				res?.status === 'Success' ||
				res?.status === 'success'
			) {
				setViewPackagesModal({
					open: true,
					data: res?.data || [],
				});
				notificationServices.generateNotification({
					type: 'success',
					message: 'Packages fetched successfully',
					config: { id: notificationId },
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: res?.message || 'Failed to fetch packages',
					config: { id: notificationId },
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Failed to fetch packages',
				config: { id: notificationId },
			});
		}
	};

	// Shift edit. The backend re-derives scheduledAt/scheduledEnd from the new
	// shift's ShiftProcess window, and only accepts the change while the order is
	// PENDING — the option is hidden for every other status.
	const [shiftEditState, setShiftEditState] = useState({
		show: false,
		item: null,
		options: [],
		loading: false,
		selected: null,
	});

	const handleShiftEditClose = () => {
		setShiftEditState({
			show: false,
			item: null,
			options: [],
			loading: false,
			selected: null,
		});
	};

	const handleShiftEditOpen = async (item) => {
		if (!item?.toProcessId) {
			notificationServices.generateNotification({
				type: 'warning',
				message: 'Shift can only be changed on orders that have a process',
			});
			return;
		}
		setShiftEditState({
			show: true,
			item,
			options: [],
			loading: true,
			selected: item?.shiftId ?? null,
		});
		try {
			// Same lookup the create screen uses for an FMS order: the shifts of the
			// order's own store that run its to-process on its scheduled day.
			const response = await shiftServices.listProcessShifts({
				data: {
					date: (item?.scheduledAt
						? moment(item?.scheduledAt, 'YYYY-MM-DD HH:mm:ss')
						: moment()
					).format('YYYY-MM-DD'),
					store: item?.storeId,
					processIds: [item?.toProcessId],
				},
			});
			if (response?.statusCode === 200) {
				setShiftEditState((prev) => {
					return {
						...prev,
						options:
							response?.data?.map((shift) => {
								return {
									label: shift?.shiftName,
									value: shift?.id,
								};
							}) ?? [],
						loading: false,
					};
				});
			} else {
				setShiftEditState((prev) => {
					return { ...prev, loading: false };
				});
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Failed to fetch shifts',
				});
			}
		} catch (error) {
			setShiftEditState((prev) => {
				return { ...prev, loading: false };
			});
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? 'Failed to fetch shifts',
			});
		}
	};

	const handleShiftEditSave = async () => {
		const { item, selected } = shiftEditState;
		if (!selected) {
			notificationServices.generateNotification({
				type: 'warning',
				message: 'Please select a shift',
			});
			return;
		}
		if (selected === item?.shiftId) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Shift is already same',
			});
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Updating Shift',
		});
		try {
			const response = await inventoryAnalyticsServices.editVendorPO({
				params: {
					poId: item?.id,
				},
				data: {
					shiftId: selected,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Shift updated',
					config: {
						id: notificationId,
					},
				});
				handleShiftEditClose();
				setUpdate((prev) => {
					return prev + 1;
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message:
						response?.errorMessage ??
						response?.message ??
						'Failed to update shift',
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? 'Failed to update shift',
				config: {
					id: notificationId,
				},
			});
		}
	};

	const searchQuery = '';
	const searchBy = 'poId';

	const { userConfig = {}, appConfig = {} } = useAuth();
	const isBakingo = appConfig?.customerId == 52;

	const { level } = userConfig?.userDetails || {};
	const { userRolesDict } = userConfig || {};
	const isInternal =
		Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') ||
		Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const procurmentRole = Object?.values?.(userRolesDict ?? {}).includes(
		'Procurement'
	);
	const levels = [3, 4];

	const handleReopenPo = (id, clientPoId) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Reopening Po ${clientPoId || ''}`,
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: 'REOPEN',
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleCancelPo = (id, clientPoId) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Order ${clientPoId || id || ''}`.trim(),
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: 'CANCEL',
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleClosePO = async (id, clientPoId) => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: `Closing Po ${clientPoId || ''}`,
		});
		try {
			const resp = await inventoryAnalyticsServices.generateGrn({
				params: {
					poId: id,
				},
			});
			notificationServices.generateNotification({
				type: 'success',
				message: resp?.status,
				config: {
					id: notificationId,
				},
			});
			setUpdate((prev) => {
				return prev + 1;
			});
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				},
			});
		}
	};

	const handleApprovePo = async (item, approveReason) => {
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'APPROVE',
						approveReason,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => prev + 1);
				toggleModal(false);
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleRejectPo = async (item, rejectionReason) => {
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'REJECT',
						rejectionReason,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => prev + 1);
				toggleModal(false, {});
				toggleAlert(false);

				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleReviewModal = async (item) => {
		toggleModal(true, {
			heading: `Items ${item?.productionPlanDescription
				? `of ${item?.productionPlanDescription} - ${item?.toProcessName ?? ''
				} ${item?.jsonData?.parentClientPoId
					? `Parent PO - ${item?.jsonData?.parentClientPoId}`
					: ''
				}`
				: ''
				}`,
			...item,
			isApprove: true,
			ignorePdfState: true,
			approvalText: 'I have checked all the items of Production Plan',
			showTotal: false,
			showPoDetails: true,
			excludedColumns: [
				'Packaged',
				'Dispatched',
				'Returned Quantity',
				'Received',
				'Returned',
				'Item Price',
				'Item Sub Total',
				'Tax Percentage',
				'Item Tax',
				'Tax value',
				'Item Amount',
				'Total Item Amount',
				'Discount %',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty',
			],
		});
	};

	const handleForwardReopen = (id, clientPoId) => {
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Forward Reopening Po ${clientPoId || ''}`,
			});
			try {
				const resp = await inventoryAnalyticsServices.carryForwardOrder(
					{
						params: {
							poId: id,
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status || 'Successfully Reopened',
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => prev + 1);
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleViewClick = (item) => {
		toggleModal(true, {
			heading: `Items ${item?.productionPlanDescription
				? `of ${item?.productionPlanDescription} - ${item?.toProcessName ?? ''
				} ${item?.jsonData?.parentClientPoId
					? `Parent PO - ${item?.jsonData?.parentClientPoId}`
					: ''
				} 
			${item?.jsonData?.childClientPoId
					? `Child PO - ${item?.jsonData?.childClientPoId}`
					: ''
				}
			`
				: ''
				}`,
			...item,
			// PO id is needed so the modal can fetch PO details — for CMS orders
			// this pulls the ingredient breakdown (cmsIngredients:true).
			poId: item?.poId ?? item?.id,
			excludedColumns: [
				'Packaged',
				'Dispatched',
				'Returned Quantity',
				'Received',
				'Returned',
				'Item Price',
				'Item Sub Total',
				'Tax Percentage',
				'Item Tax',
				'Tax value',
				'Item Amount',
				'Total Item Amount',
				'Discount %',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty',
			],
		});
	};

	const SPECIAL_ITEMS = {
		'Order Name': (orderName, item) => {
			if (!orderName) {
				return '-';
			}
			return (
				<div
					role='button'
					tabIndex={0}
					style={{
						cursor: 'pointer',
						color: '#2563eb',
						textDecoration: 'underline',
						textAlign: 'left',
					}}
					onClick={() => handleViewClick(item)}
				>
					{orderName}
				</div>
			);
		},
		Workers: (_, obj) => {
			return (
				<div>
					{obj?.jsonData?.workersByGrade?.map((worker) => {
						return (
							<div className='flex gap-2'>
								<span className='font-bold text-xs capitalize'>
									{worker?.key}
								</span>
								<span className='text-xs'>{worker?.value}</span>
							</div>
						);
					})}
				</div>
			);
		},
		ACTION: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});

			if (
				levels.includes(level) &&
				(isInternal || procurmentRole) &&
				item?.orderStatus === 'APPROVAL_PENDING' &&
				item?.orderStatus !== 'APPROVAL_REJECTED'
			) {
				return (
					<div className={styles.btns} style={{ width: '125px' }}>
						<Button
							onClick={() => handleReviewModal(item)}
							className='primary-btn w-full'
						>
							Review
						</Button>
					</div>
				);
			}

			// if (
			// 	!isBakingo &&
			// 	!item?.jsonData?.carryForward &&
			// 	['CLOSED', 'FULFILLED', 'ABANDONED'].includes(
			// 		item?.orderStatus
			// 	) &&
			// 	moment().isBetween(
			// 		moment(item?.scheduledEnd, 'YYYY-MM-DD HH:mm:ss'),
			// 		moment(item?.scheduledEnd, 'YYYY-MM-DD HH:mm:ss').add(
			// 			24,
			// 			'hours'
			// 		)
			// 	)
			// ) {
			// 	return (
			// 		<div>
			// 			<Button
			// 				variant='secondary'
			// 				onClick={() => {
			// 					toggleAlert(true, {
			// 						heading: 'Forward Reopen',
			// 						handleConfirm: () => {
			// 							handleForwardReopen(
			// 								itemId,
			// 								item?.clientPoId
			// 							);
			// 							toggleAlert(false);
			// 						},
			// 						colorReverse: true,
			// 						cancelText: 'No',
			// 						confirmText: 'Yes',
			// 						message: `Are you sure you want to Forward Reopen ${
			// 							item?.clientPoId || ''
			// 						}? This will create another Order with delta quantities. Which will be kept in approval pending`,
			// 					});
			// 				}}
			// 			>
			// 				FORWARD-REOPEN
			// 			</Button>
			// 		</div>
			// 	);
			// }

			const scheduledEnd = moment(item?.scheduledEnd, 'YYYY-MM-DD HH:mm:ss');
			const scheduledAt = moment(item?.scheduledAt, 'YYYY-MM-DD HH:mm:ss');
			const isWithinWindow = !isBakingo
				? moment().isBetween(scheduledAt, scheduledEnd.clone().add(48, 'hours'))
				: moment().isBefore(scheduledEnd.clone().endOf('day'));
			if (
				(item?.orderStatus === 'FULFILLED' ||
					item?.orderStatus === 'CLOSED' ||
					item?.orderStatus === 'ABANDONED') &&
				item?.subType === 'Work Order' && isWithinWindow
			) {

				const extraMessage = isWithinWindow
					? ' Reopening will update your scheduled date to current Date.'
					: '';
				return (
					<div
						style={{
							width: '125px',
						}}
					>
						<Button
							variant='secondary'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Re-Open',
									handleConfirm: () => {
										handleReopenPo(
											itemId,
											item?.clientPoId
										);
										toggleAlert(false);
									},
									colorReverse: true,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Re-Open ${item?.clientPoId || ''
										}${extraMessage}`,
								});
							}}
						>
							RE-OPEN
						</Button>
					</div>
				);
			}
			return (
				item?.orderStatus === 'PENDING' && (
					<div
						style={{
							width: '125px',
							display: 'flex',
							flexDirection: 'column',
							gap: '.5rem',
						}}
					>
						<Button
							variant='secondary'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Close',
									handleConfirm: () => {
										handleClosePO(itemId, item?.clientPoId);
										toggleAlert(false);
									},
									colorReverse: true,
									cancelText: 'No',
									confirmText: 'Yes',
									height: 'fit-content',
									message: `Are you sure you want to close Production Plan: ${item?.clientPoId || ''
										}?`,
								});
							}}
						>
							CLOSE
						</Button>
						<Button
							className='danger-btn'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Cancel',
									handleConfirm: () => {
										handleCancelPo(
											itemId,
											item?.clientPoId
										);
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Cancel ${item?.clientPoId || ''
										}`,
								});
							}}
						>
							Cancel
						</Button>
					</div>
				)
			);
		},
		Download: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div className={styles?.downloadDiv}>
					{item?.poURL && (
						<Chip
							size='small'
							label='Order'
							onClick={() => {
								if (item?.poURL) {
									window.open(item?.poURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
					{item?.woDocUrl && (
						<Chip
							size='small'
							label='WO'
							onClick={() => {
								if (item?.woDocUrl) {
									window.open(item?.woDocUrl);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
				</div>
			);
		},
	};

	const viewMoreOptionsList = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		'View Packages': (item, cb) => {
			if (item?.type !== 'FMCG') {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'View Packages is only available for FMCG orders',
				});
				cb();
				return;
			}
			handleViewPackages(item);
			cb();
		},
		'Update Shift': (item, cb) => {
			const order = data?.find((poItem) => {
				return poItem?.id === item?.id;
			});
			if (order?.orderStatus !== 'PENDING') {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'Shift can be changed only for PENDING orders',
				});
				cb();
				return;
			}
			handleShiftEditOpen(order);
			cb();
		},
	};

	const handleEditSubmit = async (editedValues) => {
		try {
			const response = await assetServices.editAssetTemp({
				data: editedValues,
				params: {
					type: 'PO',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? error?.message,
			});
		}
	};

	const fetchFmsOrders = (filters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setFilterValue(filters);
		const req = {
			data: {
				filters: {
					dateRangeFilter:
						filters?.productionPlan?.id?.length > 0
							? {}
							: {
								from: moment(
									filters?.dateRange?.from
								).format('YYYY-MM-DD'),
								to: moment(filters?.dateRange?.to).format(
									'YYYY-MM-DD'
								),
								dateType: filters?.timeType?.value,
							},
					processType:
						filters?.processTypes?.id?.length > 0
							? Number(filters?.processTypes.id.toString())
							: null,
					fromProcess:
						filters?.fromProcess?.id?.length > 0
							? filters?.fromProcess?.id
							: null,
					toProcess:
						filters?.toProcess?.id?.length > 0
							? filters?.toProcess?.id
							: null,
					storeId: filters?.store?.id,
					orderType: 'fms',
					subType: filters?.type,
					variantIds: [
						...new Set(
							filters?.productWithVariant?.productData?.flatMap(
								(item) => item?.variantIds
							)
						),
					],
					fmsOrderStatus: filters?.status,
					productionPlanIds: filters?.productionPlan?.id,
					...(isRefresh
						? null
						: {
							poId: search?.searchValue
								? Number(search?.searchValue)
								: null,
						}),
				},
			},
		};
		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'FMS_ORDERS_LIST',
			req,
		});
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [
			'PO ID',
			'ORDER TYPE',
			'PRODUCTION ID',
			'PRODUCTION PLAN NAME',
			'FROM PROCESS',
			'TO PROCESS',
			'STORE',
			'AVG. HOURLY SCANS',
			'CREATED ON',
			'SCHEDULED FOR',
			'SCHEDULED END',
		];
		const downloadBtn = document.createElement('a');

		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const handleUpdate = (filters) => {
		setExportFilter(filters);
		exportFilterRef.current = filters;
	};
	// const exportItemsWiseDataOld = () => {
	// 	const headers = [
	// 		'PRODUCT NAME',
	// 		'CATEGORY NAME',
	// 		'VARIANT',
	// 		'UNIT',
	// 		'ORDERED QUANTITY',
	// 		'FULFILLED',
	// 		'FROM PROCESS',
	// 	];
	// 	const totalValues = [];
	// 	data?.forEach((ele) => {
	// 		ele?.items?.forEach((item) => {
	// 			totalValues?.push([
	// 				ele?.id ?? '-',
	// 				ele?.subType,
	// 				ele?.productionPlan,
	// 				ele?.productionPlanDescription,
	// 				ele?.fromProcessName ?? '-',
	// 				ele?.toProcessName ?? '-',
	// 				ele?.storeName,
	// 				ele?.avgScans ?? '-',
	// 				moment(ele?.createdAt).format('YYYY-MM-DD') ?? '-',
	// 				ele?.scheduledAt,
	// 				ele?.scheduledEnd,
	// 				item?.productName?.replaceAll(',', "'"),
	// 				item?.categoryName,
	// 				item?.variantName,
	// 				item?.unit,
	// 				item?.qty,
	// 				item?.fulfilled,
	// 				item?.fromProcess ?? '-',
	// 			]);
	// 		});
	// 	});
	// 	handleExcelDownload(headers, totalValues, 'FMS_ORDER');
	// };

	const exportItemsWiseData = async (filters) => {
		const currentFilters = exportFilterRef.current;
		const req = {
			data: {
				export: true,
				filters: {
					dateRangeFilter:
						currentFilters?.productionPlan?.id?.length > 0
							? {}
							: {
								from: moment(
									currentFilters?.dateRange?.from
								).format('YYYY-MM-DD'),
								to: moment(
									currentFilters?.dateRange?.to
								).format('YYYY-MM-DD'),
								dateType: currentFilters?.timeType?.value,
							},
					processType:
						currentFilters?.processTypes?.id?.length > 0
							? Number(
								currentFilters?.processTypes?.id.toString()
							)
							: null,
					fromProcess:
						currentFilters?.fromProcess?.id?.length > 0
							? currentFilters?.fromProcess?.id
							: null,
					toProcess:
						currentFilters?.toProcess?.id?.length > 0
							? currentFilters?.toProcess?.id
							: null,
					storeId: currentFilters?.store?.id,
					variantIds: [
						...new Set(
							currentFilters?.productWithVariant?.productData?.flatMap(
								(item) => item?.variantIds
							)
						),
					],
					orderType: 'fms',
					subType: currentFilters?.type,
					fmsOrderStatus: currentFilters?.status,
					productionPlanIds: currentFilters?.productionPlan?.id,
					poId: Number(search?.searchValue),
				},
			},
		};
		try {
			const response = await analyticsServices.exportFmsOrders({
				req: {
					...req,
				},
			});
			handleResponseStreamDownload(response, 'FMS_ORDERS.csv');
		} catch (error) { }
	};

	const dropDownItems = [
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by PO ID',
			getData: true,
		},
	];

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			fetchFmsOrders(filterValue);
			setSearch({});
		}
	}, [search?.searchValue]);

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			fetchFmsOrders(filterValue);
		}
	};
	const statusList = [
		{
			id: 'CANCELLED',
			title: 'CANCELLED',
		},
		{
			id: 'FULFILLED',
			title: 'FULFILLED',
		},
		{
			id: 'VERIFICATION',
			title: 'VERIFICATION',
		},
		{
			id: 'DISPATCH',
			title: 'DISPATCH',
		},
		{
			id: 'UNLOADING',
			title: 'UNLOADING',
		},
		{
			id: 'PENDING',
			title: 'PENDING',
		},
		{
			id: 'ABANDONED',
			title: 'ABANDONED',
		},
	];
	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			process: false,
			product: false,
		},
		store: {
			text: 'Kitchen',
			show: true,
		},
		dateRangeWithType: {
			show: true,
		},
		fromProcess: {
			text: 'Deliver From Process',
			show: true,
			multiSelect: true,
		},
		toProcess: {
			text: 'Deliver To Process',
			show: true,
			multiSelect: true,
		},
		productionPlan: {
			text: 'Production Plans',
			show: true,
		},
		status: {
			text: 'OrderStatus',
			show: true,
		},
		type: {
			text: 'Order Type',
			show: true,
			list: [
				{
					label: 'Internal Transfer',
					type: 'INTERNAL_TRANSFER',
				},
				{
					label: 'Work Order',
					type: 'WORK_ORDER',
				},
				{
					label: 'Warehouse',
					type: 'WAREHOUSE',
				},
				{
					label: 'Consumption Transfer (Machine)',
					type: 'CMS_INDENT',
				},
				{
					label: 'Consumption Transfer (App)',
					type: 'CONSUMPTION_TRANSFER',
				},
			],
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
	};

	const exportInfo = {
		showExportBtn: true,
	};

	const handleOrderCompletion = (item) => {
		const totalQuantity = item?.items?.reduce(
			(acc, curr) => acc + curr?.qty,
			0
		);
		const fullfiledQuantity = item?.items?.reduce(
			(acc, curr) => acc + curr?.fulfilled,
			0
		);
		const completionPercentage = Math.min(
			(fullfiledQuantity / totalQuantity) * 100,
			100
		);
		return completionPercentage ? `${completionPercentage.toFixed(2)}%` : '0%';
	};
	return (
		<div className={styles.root}>
			<AlertModal />
			<Dialog
				open={viewPackagesModal.open}
				onClose={() => setViewPackagesModal({ open: false, data: [] })}
				maxWidth='md'
				fullWidth
			>
				<DialogTitle>Packages</DialogTitle>
				<DialogContent>
					<div className='w-full mt-4 overflow-x-auto'>
						<table className='w-full text-left border-collapse'>
							<thead>
								<tr>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										QR Code
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Item Name
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Item Count
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Total Weight
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Earliest Expiry
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Created At
									</th>
									<th className='border-b py-2 px-4 font-semibold text-gray-700 whitespace-nowrap'>
										Completed By
									</th>
								</tr>
							</thead>
							<tbody>
								{viewPackagesModal.data?.map((pkg, idx) => (
									<tr key={idx}>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.qrCode || '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.variantName || '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.itemCount ?? '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.totalWeight ?? '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.earliestExpiry || '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.createdAt
												? moment(pkg.createdAt).format(
													'YYYY-MM-DD HH:mm:ss'
												)
												: '-'}
										</td>
										<td className='border-b py-2 px-4 text-gray-600 whitespace-nowrap'>
											{pkg.completedBy || '-'}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() =>
							setViewPackagesModal({ open: false, data: [] })
						}
						variant='secondary'
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
			<POItemsModal
				handleConfirm={handleApprovePo}
				handleReject={handleRejectPo}
			/>
			{shiftEditState?.show && (
				<div className='fixed inset-0 z-[1300] flex items-center justify-center bg-black/40'>
					<div className='w-[380px] max-w-[92vw] bg-white rounded-xl shadow-xl p-5'>
						<div className='mb-1 font-semibold text-base'>
							{`Shift for ${shiftEditState?.item?.clientPoId ?? ''}`}
						</div>
						<p className='mb-4 text-xs text-gray-500'>
							Scheduled time will move to the selected shift.
						</p>
						<SelectPicker
							data={shiftEditState?.options ?? []}
							value={shiftEditState?.selected}
							onChange={(val) => {
								setShiftEditState((prev) => {
									return {
										...prev,
										selected: val,
									};
								});
							}}
							placeholder={
								shiftEditState?.loading
									? 'Loading shifts…'
									: 'Select Shift'
							}
							loading={shiftEditState?.loading}
							cleanable={false}
							searchable
							block
							menuClassName='z-[1400]'
						/>
						{!shiftEditState?.loading &&
							(shiftEditState?.options?.length ?? 0) === 0 && (
								<p className='mt-2 text-xs text-red-500'>
									No shifts found for this order.
								</p>
							)}
						<div className='mt-5 flex items-center justify-end gap-2'>
							<Button
								variant='outline'
								onClick={handleShiftEditClose}
							>
								Cancel
							</Button>
							<Button
								className='primary-btn'
								onClick={handleShiftEditSave}
								disabled={shiftEditState?.loading}
							>
								Save
							</Button>
						</div>
					</div>
				</div>
			)}
			<VanImageModal handleEditSubmit={handleEditSubmit} />
			<div className='flex flex-col gap-2 justify-between m-4 w-full p-2'>
				<div className='flex justify-between items-center gap-2'>
					<span className='font-bold text-[16px]'>
						Factory Management Orders{' '}
					</span>
					{level !== 1 && (
						<div className='flex gap-2'>
							<Button
								onClick={() => {
									const redirectUrl = `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER
										}?typeId=${5}`;
									history.push(redirectUrl, {
										prevPath:
											location?.pathname +
											location?.search,
									});
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Transfer order
							</Button>
							<Button
								onClick={() => {
									const redirectUrl = `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER
										}?typeId=${6}`;
									history.push(redirectUrl, {
										prevPath:
											location?.pathname +
											location?.search,
									});
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Work Order
							</Button>
						</div>
					)}
				</div>
				<div className='flex gap-3 w-full justify-start items-center py-1'>
					<div className='w-[90%]'>
						<GlobalSearch
							dropDownOptions={dropDownItems}
							setSelectedValue={setSearch}
							handleValue={handleCall}
							isRefresh={isRefresh}
						/>
					</div>
					<Tooltip title='Refresh Factory Management Orders'>
						<RefreshCcw
							className='size-5 cursor-pointer'
							onClick={() => {
								fetchFmsOrders(filterValue, true);
							}}
						/>
					</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								handleDataExport: (req) =>
									exportItemsWiseData(req),
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filterValue)}
			<ImagesFinder
				timeTypeArray={dateTypeArr}
				onSubmit={fetchFmsOrders}
				update={update}
				orderText
				statusList={statusList}
				filtersInfo={filtersInfo}
				onUpdate={handleUpdate}
				exportInfo={exportInfo}
			/>
			<div
				style={{
					width: '100%',
					overflow: 'auto',
					flex: 1,
					minHeight: 0,
				}}
			>
				<ListTable
					fixedHeaderTop={0}
					hasDateRange
					showTotal
					allowExport={false}
					allowChangeColumn
					defaultVisibleColumns={[
						'PO Id',
						'Order Name',
						'Order Type',
						'Shift',
						'Status',
						'Deliver From Process',
						'Deliver To Process',
						'CREATED ON',
						'SCHEDULED FOR',
					]}
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={data?.map((ele) => {
						return {
							...ele,
							type: PO_TYPE_MAP[ele?.type] ?? ele?.type ?? '-',
							orderStatus: handleOrderStatus(ele?.orderStatus),
							orderCompletion: handleOrderCompletion(ele),
						};
					})}
					actions={[...ACTION_COLUMNS]}
					special={SPECIAL_ITEMS}
					viewMoreOptionsList={viewMoreOptionsList}
					handleViewClick={handleViewClick}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const stores = state?.form?.STORES?.data?.LIST;
	const { navState, userPermissions } = state?.navigation;
	const { FMS_ORDERS_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const { userList } = state?.auth;
	return {
		data,
		stores,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	fetchOrdersList: analyticsAction.gateway,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions?.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(FMSOrdersListPage);
